export const isNonProduction = (): boolean => {
  const hostname = window.location.hostname;
  return (
    hostname === "localhost" ||
    hostname.startsWith("internal.") ||
    hostname.startsWith("staging.")
  );
};
